class BabyMattressCalculator {
  constructor() {
    this.form = document.getElementById('baby-mattress-calculator');
    if (!this.form) return;

    this.selectType = document.getElementById('contact-form-type_of_mattress');
    this.inputLength = document.getElementById('contact-form-mattress_length');
    this.inputWidth = document.getElementById('contact-form-mattress_width');
    this.inputRectangularCurved = this.form.querySelectorAll('input[name="contact[rectangular_or_curved]"]');
    this.inputDeliveryMethod = this.form.querySelectorAll('input[name="contact[delivery_method]"]');

    this.fieldRectangularCurved = this.form.querySelector('.field-rectangular-curved');
    this.fieldLength = this.form.querySelector('.field-mattress-length');
    this.fieldWidth = this.form.querySelector('.field-mattress-width');
    this.fieldPrice = this.form.querySelector('.field-price');

    this.mattresses = {
      cot: {
        label: 'Cot',
        maxLength: 140,
        maxWidth: 80,
        curvedExtra: 60,
        prices: [
          {
            maxLength: 120,
            maxWidth: 60,
            price: 669
          },
          {
            maxLength: 130,
            maxWidth: 70,
            price: 679
          },
          {
            maxLength: 140,
            maxWidth: 80,
            price: 699
          }
        ]
      },
      cradle: {
        label: 'Cradle',
        maxLength: 100,
        maxWidth: 50,
        curvedExtra: 40,
        prices: [
          {
            maxLength: 100,
            maxWidth: 50,
            price: 289
          }
        ]
      },
      bassinet: {
        label: 'Bassinet',
        maxLength: 80,
        maxWidth: 40,
        curvedExtra: 40,
        prices: [
          {
            maxLength: 80,
            maxWidth: 40,
            price: 259
          }
        ]
      }
    };

    this.deliveryRates = {
      cot: 69.95,
      cradle: 59.95,
      bassinet: 49.95
    };

    this.init();
  }
  
  init() {
    this.bindEvents();
    this.calculate();
  }
	
	bindEvents() {
    this.selectType.addEventListener('change', () => this.calculate());
    this.inputLength.addEventListener('input', () => this.calculate());
    this.inputWidth.addEventListener('input', () => this.calculate());

    this.inputRectangularCurved.forEach(input => {
      input.addEventListener('change', () => this.calculate());
    });

    this.inputDeliveryMethod.forEach(input => {
      input.addEventListener('change', () => this.calculate());
    });
  }

  calculate() {
    const type = this.selectType.value.toLowerCase();
    const mattress = this.mattresses[type];
    if (!mattress) return;

    const length = parseFloat(this.inputLength.value) || 0;
    const width = parseFloat(this.inputWidth.value) || 0;
    const shape = this.getCheckedValue(this.inputRectangularCurved);
    const deliveryMethod = this.getCheckedValue(this.inputDeliveryMethod);
    const basePriceItem = mattress.prices.find(item => {
      return length > 0 && width > 0 && length <= item.maxLength && width <= item.maxWidth;
    });
    
    this.updateLabels(mattress.label);
    this.updateDescription(mattress);

    const basePrice = basePriceItem?.price || 0;
    const curvedExtra = shape === 'Curved' ? mattress.curvedExtra : 0;
    const deliveryPrice = deliveryMethod === 'Delivered to Home' ? this.deliveryRates[type] : 0;
    const totalPrice = basePrice + curvedExtra + deliveryPrice;
    let priceHtml = '';
    
    if (basePrice > 0) {
      priceHtml += `<p>${mattress.label} Mattress: $${basePrice.toFixed(2)}</p>`;
    } else if (length > mattress.maxLength || width > mattress.maxWidth) {
      priceHtml += `<p>Please contact us for a customised price for ${mattress.label} Mattress.</p>`;
    }

    if (curvedExtra > 0) {
      priceHtml += `<p>Additional Curved: $${curvedExtra.toFixed(2)}</p>`;
    }

    if (deliveryPrice > 0) {
      priceHtml += `<p>Delivery rates for ${mattress.label} Mattress: $${deliveryPrice.toFixed(2)}</p>`;
    }

    if (basePrice > 0 && totalPrice > 0) {
      priceHtml += `<p><strong>Total Price: $${totalPrice.toFixed(2)}</strong></p>`;
    }
    
    if (basePriceItem) {
      const summary = [
        `${mattress.label} Mattress length up to ${basePriceItem.maxLength}cm and width up to ${basePriceItem.maxWidth}cm`
      ];

      if (curvedExtra > 0) {
        summary.push(shape);
      }
      
      summary.push(deliveryMethod);
      
      priceHtml += `<p>${summary.filter(Boolean).join(' + ')}</p>`;
    }

    if (priceHtml) {
      this.fieldPrice.classList.remove('d-none');
      this.fieldPrice.innerHTML = priceHtml;
    } else {
      this.fieldPrice.classList.add('d-none');
      this.fieldPrice.innerHTML = '';
    }
  }

  updateLabels(type) {
    this.fieldRectangularCurved.querySelector('.form__label').innerHTML = `${type} Rectangular or Curved?`;
    this.fieldLength.querySelector('.form__label').innerHTML = `${type} Length in cm?`;
    this.fieldWidth.querySelector('.form__label').innerHTML = `${type} Width in cm?`;
  }
  
  updateDescription(mattress) {
    this.fieldLength.querySelector('.form__desc').innerHTML = `Please enter a number from <strong>1</strong> to <strong>${mattress.maxLength}</strong>.`;
    this.fieldWidth.querySelector('.form__desc').innerHTML = `Please enter a number from <strong>1</strong> to <strong>${mattress.maxWidth}</strong>.`;

    this.inputLength.max = mattress.maxLength;
    this.inputWidth.max = mattress.maxWidth;
    
    this.inputLength.min = 1;
    this.inputWidth.min = 1;
  }
  
  getCheckedValue(inputs) {
    const checked = [...inputs].find(input => input.checked);
    return checked ? checked.value : '';
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	new BabyMattressCalculator();
});